import PatientsPage from './PatientsPage'

export default PatientsPage
